import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAidungeonComponent } from './simple-icons-aidungeon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAidungeonComponent ],
    exports:      [ SimpleIconsAidungeonComponent ],
    bootstrap:    []
})
export class SimpleIconsAidungeonModule {}
